module.exports = __webpack_public_path__ + "img/paysyccess.b73c5000.png";